import api from "../../../api";

export function getCommunityDetails(id, page=1) {
  return api.get(`get-community-details/${id}?page=${page}&pageSize=10`);
}

export function getCommunityOrderStats(id) {
  return api.get(`get-community-details-order-stats/${id}`);
}

export function downloadCommunity(id){
  return api.get(`download-community-details/${id}`);
}

